import { Button, Form, Input, Typography, Result, Select, Image as ImageTag } from 'antd'
import { UploadOutlined, DeleteFilled } from '@ant-design/icons'
import { useState } from 'react'
import { apiAddReportType } from '../../../../utils/api'
import { prMain } from '../../../../themeConfig'
// import { openMessage } from '../../Utils/MessageDisplay'

export const AddServiceModal = ({ setOpenAdd, dependencies, setUpdated }) => {
    const { Text } = Typography
    const [state, setState] = useState({
        name: '',
        dependencyId: 0,
        min_time: 0,
        max_time: 0,
        active: true
    })
    const [icon, setIcon] = useState([])
    const [url, setUrl] = useState()
    const [addResult, setAddResult] = useState(false)
    const [iconError, setIconError] = useState(false)

    const handleChangeHours = (e, name) => {
        if (e.target.value === '') {
            e.target.value = 0
        }

        const regex = /[^\d]/u;
        if (regex.test(e.target.value)) {
            e.target.value = parseInt(e.target.value.substring(0, e.target.value.length - 1));
        } else {
            setState(prev => ({ ...prev, [name]: parseInt(e.target.value) }))
        }
    }

    const handleUpload = (e) => {
        setIconError(false)
        if (!e) return

        var reader = new FileReader()

        reader.readAsDataURL(e.target.files[0])
        reader.onload = function (value) {
            var image = new Image()
            image.src = value.target.result

            image.onload = function () {
                var h = this.height
                var w = this.width

                if (h > 500 || w > 500) {
                    console.log('mal')
                    console.log(w + ' x ' + h)
                    setIconError(true)
                } else {
                    setIconError(false)
                    console.log('bien')
                    console.log(w + ' x ' + h)

                }
            }
        }


        setIcon(e.target.files[0])
        setUrl(URL.createObjectURL(e.target.files[0]))

    }
    const handleRemove = () => {
        setIcon([])
        setUrl('')
    }

    const handleChange = (e, name) => {
        switch (name) {
            case "dependencyId":
                setState(prev => ({ ...prev, [name]: e }))
                break;

            case "name":
                setState(prev => ({ ...prev, [name]: e.target.value }))
                break;

            case "icon":
                setState(prev => ({ ...prev, [name]: e.file }))
                break;

            default:
                break;
        }

    }

    const handleSave = () => {

        let params = {
            "name": state.name,
            "max_time": state.max_time,
            "min_time": state.min_time,
            "dependencyId": state.dependencyId,
            "active": true
        }

        apiAddReportType(icon, params).then((response) => {

            setUpdated(true)
            setAddResult(true)
        })

    }

    return (

        <div>
            {
                addResult
                ? <Result
                status='success'
                title='Servicio A&ntilde;adido'
                subTitle=''
                extra={[
                    <Button key='ok' type='primary' onClick={() => setOpenAdd(false)} autoFocus >
                        Volver
                    </Button>
                ]}
            />
                : <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Form.Item
                            style={{ width: '50%' }}

                        >
                            <Text>Nombre</Text>
                            <Input onChange={(e) => handleChange(e, 'name')}>
                            </Input>
                        </Form.Item>

                        <Form.Item
                            style={{ marginLeft: 30, width: '50%' }}
                        >
                            <Text>Dependencia</Text>
                            <Select onChange={(e) => handleChange(e, "dependencyId")}>
                                {dependencies.map((item) => (
                                    <Select.Option value={item.id} key={item.id}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Form.Item
                            style={{ marginRight: 30, width: '50%' }}
                            help={state.min_time > state.max_time ? 'El mínimo debe ser menor que el máximo' : ''}
                            validateStatus={state.min_time > state.max_time ? "error" : "success"}

                        >
                            <Text>M&iacute;nimo (horas)</Text>
                            <Input onChange={(e) => handleChangeHours(e, 'min_time')} value={state.min_time} >
                            </Input>
                        </Form.Item>

                        <Form.Item
                            style={{ width: '50%' }}
                            help={state.min_time > state.max_time ? 'El mínimo debe ser menor que el máximo' : ''}
                            validateStatus={state.min_time > state.max_time ? "error" : "success"}

                        >
                            <Text>M&aacute;ximo (horas)</Text>
                            <Input onChange={(e) => handleChangeHours(e, 'max_time')} value={state.max_time}>
                            </Input>
                        </Form.Item>
                    </div>

                    <div style={{ width: '100%', height: 75, display: 'flex', flexDirection: 'row' }}>
                        <div style = {{ display: 'flex', flexDirection: 'column' }}>

                        <label style={{ backgroundColor: prMain, height: 'fit-content', width: 'fit-content', padding: '5px 15px', borderRadius: 50 }} className='input-container' >
                            <UploadOutlined style={{ marginRight: 5 }} />
                            <input
                                id={'icono'}
                                className='inputSelect'
                                type="file"
                                accept='image/png'
                                name={'icono'}
                                onChange={handleUpload}
                            />
                            Seleccionar Icono
                        </label>
                        <Text style = {{ fontSize: 12, color: iconError ? "#ff0000" : '#aaaaaa', marginTop: 20 }}>
                            Favor de subir icono de m&aacute;ximo 500 x 500 pixeles
                        </Text>
                        </div>

                        <div style={{ marginLeft: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            {
                                url
                                    ? <ImageTag id={1} src={url} alt={'Icono'} height={75} width={75} style={{ objectFit: 'cover' }} />
                                    : <ImageTag
                                        style={{ objectFit: 'cover' }}
                                        width={75}
                                        height={75}
                                        src="error"
                                        fallback="data:image/png;base64,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"
                                    />
                            }
                            <Button icon={<DeleteFilled />} disabled={!url} type='link' onClick={() => handleRemove()}>Remover</Button>
                        </div>
                    </div>

                    <Button
                        style={{ marginTop: 20, width: '25%' }}
                        disabled={
                            !state.name ||
                            !state.dependencyId ||
                            !state.min_time ||
                            !state.max_time ||
                            state.min_time > state.max_time ||
                            icon.length === 0 ||
                            iconError}
                        type='primary'
                        onClick={handleSave}
                    >Guardar</Button>
                </div>
            }
        </div>
    )

}